export default __webpack_public_path__ + "static/media/Firefox-logo.35e6ed5f.png";